export const Action = {
    GET_USER: "GET_USER",
    CHANGE_SILENT: "CHANGE_SILENT"
};
export const Mutation = {
    SAVE_USER: "SAVE_USER",
    CHANGE_SHOW_SETTINGS: "CHANGE_SHOW_SETTINGS",
    SAVE_SILENT: "SAVE_SILENT"
};